<template>
  <div class="min-h-screen bg-black text-white py-8 px-4 md:px-8 md:mt-16">
    <div class="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
      <!-- Coluna da esquerda (informacoes do evento) -->
      <div class="md:col-span-2">
        <div class="w-full flex justify-center">
          <img
            :src="
              event?.event?.banner !== null && event?.event?.banner !== '[]'
                ? fileUrl + event?.event?.banner
                : appLogo
            "
            :alt="event?.event?.title"
            class="w-full rounded-lg object-cover max-h-[300px] max-w-[400px]"
          />
        </div>

        <!-- Titulo do treinamento -->
        <div class="w-full flex justify-center tracking-normal">
          <div class="text-left md:max-w-[400px]">
            <h1 class="text-3xl font-bold mt-6 tracking-wide uppercase">
              {{ overview?.assessment?.title }}
            </h1>
          </div>
        </div>

        <!-- INFORMAÇÕES -->
        <div class="w-full flex justify-center font-inter tracking-normal">
          <div class="text-left md:max-w-[400px]">
            <div class="flex items-center gap-2 mt-4 text-gray-300">
              <PhListNumbers class="w-5 h-5" />
              <span
                >qtd. perguntas:
                {{ overview?.assessment?.questions_count }}</span
              >
            </div>

            <div class="flex items-center gap-2 mt-2 text-gray-300">
              <PhGraduationCap class="w-5 h-5" />
              <span
                >nota para aprovação:
                {{ overview?.assessment?.min_grade_required }}
              </span>
            </div>

            <div class="flex items-center gap-2 mt-2 text-gray-300">
              <PhTarget class="w-5 h-5" />
              <span
                >tentativas permitidas:
                {{ overview?.assessment?.max_attempts }}</span
              >
            </div>

            <!-- descrição do treinamento -->
            <div class="mt-8 font-inter">
              <h2 class="text-xl font-semibold mb-2">
                Detalhes do treinamento
              </h2>
              <p class="text-gray-400">
                {{ event?.event?.description }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Coluna da direita (checkout/resumo) -->
      <div class="relative">
        <div class="bg-zinc-900 rounded-lg p-6 sticky top-8 z-20">
          <div class="flex justify-between items-center mb-4">
            <section
              class="flex flex-col gap-y-4 w-full justify-start text-start"
            >
              <!-- tentativas -->
              <div class="flex justify-between">
                <span class="text-lg font-semibold tracking-wide uppercase">
                  Tentativas restantes:
                </span>
                <span
                  class="text-xl font-bold tracking-wide"
                  v-if="!isNaN(remaningAttempt())"
                >
                  {{ remaningAttempt() }} /
                  {{ overview?.assessment?.max_attempts }}
                </span>
              </div>

              <!-- pontuação -->
              <div v-if="overview?.attempts?.best">
                <div class="flex justify-between">
                  <span class="text-lg font-semibold tracking-wide uppercase">
                    Nota mais alta:
                  </span>
                  <span class="text-xl font-bold text-green-400 tracking-wide">
                    {{ overview?.attempts?.best?.score }}
                  </span>
                </div>

                <div class="flex justify-between">
                  <span class="text-lg font-semibold tracking-wide uppercase">
                    Status:
                  </span>
                  <span
                    class="text-xl font-bold tracking-wide"
                    :class="statusColor(overview?.attempts?.best?.status)"
                  >
                    {{ statusLabel(overview?.attempts?.best?.status) }}
                  </span>
                </div>
              </div>
            </section>
          </div>

          <!-- botão de ação -->
          <div :key="canStart">
            <button
              v-if="canStart"
              class="w-full rounded-lg py-3 text-2xl md:text-xl text-center focus:outline-none uppercase text-white font-bold tracking-wide bg-[#d20a0a] border-2 border-red-700 hover:bg-white hover:text-red-700 transition-colors duration-300 disabled:hover:text-gray-300 disabled:text-gray-400 disabled:bg-[#222222] disabled:border-2 disabled:border-gray-700 disabled:opacity-60 disabled:cursor-not-allowed"
              @click="goToAssessment()"
            >
              REALIZAR TENTATIVA
            </button>

            <button
              v-else
              class="w-full rounded-lg py-3 text-2xl md:text-xl text-center focus:outline-none uppercase text-white font-bold tracking-wide bg-[#d20a0a] border-2 border-red-700 hover:bg-white hover:text-red-700 transition-colors duration-300 disabled:hover:text-gray-300 disabled:text-gray-400 disabled:bg-[#222222] disabled:border-2 disabled:border-gray-700 disabled:opacity-60 disabled:cursor-not-allowed"
              @click="goToWhatsapp()"
            >
              SOLICITAR MAIS TENTATIVAS
            </button>
          </div>
        </div>

        <!-- tentativas anteriores -->
        <div
          class="rounded-lg p-4 sticky z-10"
          v-if="overview?.attempts?.allAttempts?.length"
        >
          <div class="flex justify-between items-center mb-4">
            <section
              class="flex flex-col gap-y-1 w-full justify-start text-start text-gray-300"
            >
              <div class="flex justify-between">
                <span class="text-lg tracking-wide uppercase">
                  Todas as tentativas
                </span>
              </div>

              <div
                v-for="(value, item) in overview?.attempts?.allAttempts"
                :key="value?.started_at"
              >
                <div
                  class="flex justify-between border-b border-gray-200 border-opacity-20 text-gray-500"
                >
                  <span class="text-lg tracking-wide uppercase my-auto">
                    tentativa {{ item + 1 }}:
                  </span>

                  <span class="text-sm font-bold tracking-wider text-end w-2/4 ml-auto">
                    nota: {{ value?.score }} <br />
                    <span :class="statusColor(value?.status)">
                      {{ statusLabel(value?.status) }}
                    </span>
                  </span>

                  <router-link
                    class="my-auto mx-auto w-1/12 h-[1.5rem] bg-zinc-900 rounded-full flex justify-center"
                    :to="{
                      name: 'avaliable-result',
                      params: {
                        attemptId: value?.id,
                        tId: eventId
                      },
                    }"
                  >
                    <component 
                      :is="PhArrowRight"
                      class="my-auto mx-auto"
                    ></component>
                  </router-link>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import router from "@/router";
import SharedService from "@/shared/services/shared";
import { dataShared } from "@/shared/store";
import {
  PhListNumbers,
  PhGraduationCap,
  PhTarget,
  PhArrowRight,
} from "@phosphor-icons/vue";
import { computed, onMounted, ref, onBeforeMount } from "vue";
import { useRoute } from "vue-router";
import defaultLogo from "@/assets/logo/icon.png";
import { dataAssessment } from "@/shared/store/assessment";
import { showToast as toast } from "@/helpers/UseToasts";

const route = useRoute();
const fileUrl = process.env.VUE_APP_IMAGE_SERVE + "storage/";
const eventId = route.params.id;
const event = ref({});
const sponsorshipPage = ref(false);
const overview = computed(() => dataAssessment.getters["overview"]);
const canStart = computed(() => dataAssessment.getters["canStart"]);
const remaining = computed(() => dataAssessment.getters["attemptsRemaining"]);

const customer = computed(() => dataShared.getters.getDataByUserLogged);
const appLogo = computed(() => {
  return dataShared.getters.getLogo || defaultLogo;
});

const statusColor = (status) =>
  ({
    in_progress: "text-blue-400",
    passed: "text-green-400",
    failed: "text-red-400",
    abandoned: "text-orange-600",
    timeout: "text-white",
  }[status] || "text-gray-400");

const statusLabel = (label) =>
  ({
    in_progress: "em andamento",
    passed: "aprovado",
    failed: "reprovado",
    abandoned: "abandonado",
    timeout: "tempo esgotado",
  }[label] || "em andamento");

async function getItem() {
  dataShared.dispatch("activeLoading");
  await SharedService.getEventById(eventId)
    .then((res) => {
      sponsorshipPage.value = false;
      event.value.event = res.data;
      dataShared.dispatch("desactiveLoading");
    })
    .catch((err) => {
      dataShared.dispatch("desactiveLoading");
      if (err?.response?.data?.error && err.response.data.status === 400) {
        router.push({ name: "home" });
        return toast("Aviso", err.response.data.message, "error");
      }

      if (err?.response?.data?.error && err.response.data.status === 404) {
        router.push({ name: "home" });
        return toast("Aviso", err.response.data.message, "error");
      }

      if (err?.response?.data?.error && err.response.data.status === 429) {
        router.push({ name: "auth" });
        return toast("Aviso", err.response.data.message, "error");
      }
    });
}

// ir para página da prova
async function goToAssessment() {
  if (!canStart.value) return;
  await dataAssessment.dispatch("startAttempt", eventId);

  router.push({
    name: "avaliable",
    params: {
      id: eventId,
    },
  });
}

function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

async function goToWhatsapp() {
  let phone = "15 99704-4678";
  const formattedPhone = phone
    .replace(/\D/g, "")
    .replace(/^0/, "")
    .replace(/^/, "55");

  const assessment = overview.value?.assessment?.title ?? 'PLATAFORMA X';

  const message = `Olá *${"X Solution,"}* tudo bem?%0AAqui é o *${
    customer.value?.name.split(" ")[0]
  }*%0A%0AGostaria de solicitar a vocês mais uma tentativa na seguinte prova:%0A%0A*${assessment}*
  %0A%0AMuito obrigado e até breve!`;

  const whatsappUrl = `https://wa.me/${formattedPhone}?text=${message}`;

  if (isIOS()) {
    return (location.href = whatsappUrl);
  }

  toast("Sucesso", "Sua solicitação foi enviada", "success");

  return window.open(whatsappUrl, "_blank");
}

function remaningAttempt() {
  return (
    Number(overview.value?.assessment?.max_attempts) -
    Number(overview.value?.attempts?.used)
  );
}

onBeforeMount(async () => {
  dataShared.dispatch("activeLoading");
});

onMounted(async () => {
  await dataShared.dispatch("fetchLoggedUser");

  // initFlowbite()
  window.scrollTo(-10, -10);

  Promise.all([getItem()]);

  if (dataShared.getters.getDataByUserLogged)
    await dataAssessment.dispatch("loadOverview", eventId).catch((err) => {
      toast("Aviso", "Prova não encontrada", "error");
    });

  // dataShared.dispatch('desactiveLoading')
});
</script>

<style scoped>
@media (max-width: 768px) {
  .sticky {
    position: relative;
    top: unset;
  }
}
</style>
